// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".restart-rust-detector-task-dialog[data-v-4e4e1000] .el-dialog{width:var(--common-dialog-medium-width)}.restart-rust-detector-task-dialog .hint[data-v-4e4e1000]{padding:var(--base-size-8) var(--base-size-16);margin-bottom:var(--base-size-20)}", ""]);
// Exports
module.exports = exports;
